/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileFormatTxtIcon16Solid = forwardRef('FileFormatTxtIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.597 1.586A2 2 0 0 0 9.183 1H4.5A2.5 2.5 0 0 0 2 3.5V4h11.011l-2.414-2.414Z" }),
        React.createElement("path", { d: "M2 12.5V12h12v.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 12.5Z" }),
        React.createElement("path", { d: "M4.98 5.096H.308v1.112h1.68v4.568h1.296V6.208H4.98V5.096Z" }),
        React.createElement("path", { d: "M10.898 10.776 8.802 7.752l1.864-2.656h-1.44L8.05 6.832 6.874 5.096H5.41l1.856 2.648-2.088 3.032h1.424l1.432-2.08 1.416 2.08h1.448Z" }),
        React.createElement("path", { d: "M15.773 5.096h-4.672v1.112h1.68v4.568h1.296V6.208h1.696V5.096Z" })));
});
